// extracted by mini-css-extract-plugin
export default {"modal":"modal__VQOoi","content":"content__mkgj9"};